import axios from "axios";
import * as Preferences from "./Preferences";

export const UpdateSessionBalance = (sessionID, centAmount, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.OTHER_HANDLER_UPDATE_SESSION_BALANCE;

  //zovi axios
  axios
    .post(svcUrl, {
      userSessionID: sessionID,
      amountCents: centAmount
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      callback(null);
    });
};

export const LoginUserByUsernamePassword = (
  terminalGUID,
  username,
  password,
  callback
) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.OTHER_HANDLER_LOGIN_BY_USERNAME_PASSWORD;

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      username: username,
      password: password
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const LoginUserByToken = (terminalGUID, userToken, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.OTHER_HANDLER_LOGIN_BY_USER_TOKEN;

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      userToken: userToken
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};



// WEBPACK FOOTER //
// ./src/Communication/OtherServicesHandler.js